/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FAnonymousType112 } from './FAnonymousType112';
import {
    FAnonymousType112FromJSON,
    FAnonymousType112FromJSONTyped,
    FAnonymousType112ToJSON,
    FAnonymousType112ToJSONTyped,
} from './FAnonymousType112';

/**
 * 
 * @export
 * @interface FAnonymousType104
 */
export interface FAnonymousType104 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType104
     */
    id?: number;
    /**
     * 
     * @type {FAnonymousType112}
     * @memberof FAnonymousType104
     */
    definition?: FAnonymousType112;
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType104
     */
    sessionId?: number;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType104
     */
    data?: string | null;
}

/**
 * Check if a given object implements the FAnonymousType104 interface.
 */
export function instanceOfFAnonymousType104(value: object): value is FAnonymousType104 {
    return true;
}

export function FAnonymousType104FromJSON(json: any): FAnonymousType104 {
    return FAnonymousType104FromJSONTyped(json, false);
}

export function FAnonymousType104FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType104 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'definition': json['definition'] == null ? undefined : FAnonymousType112FromJSON(json['definition']),
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function FAnonymousType104ToJSON(json: any): FAnonymousType104 {
    return FAnonymousType104ToJSONTyped(json, false);
}

export function FAnonymousType104ToJSONTyped(value?: FAnonymousType104 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'definition': FAnonymousType112ToJSON(value['definition']),
        'sessionId': value['sessionId'],
        'data': value['data'],
    };
}

